import { resolveValueDisplay } from '@app/hcs-shared';
import { MissingDataException } from '@nu-art/ts-common';
export const translateFishboneResultsToTooltipData = (modules, variableId, results) => {
    const data = {};
    if (!variableId)
        return data;
    //Get Variable
    const variable = modules.variable.cache.unique(variableId);
    if (!variable)
        throw new MissingDataException(`Could not find variable for id ${variableId}`);
    data.variable = variable;
    data.metadata = {};
    data.metadata.source = results?.[0].source;
    //Translate Results
    data.results = [];
    results?.forEach(fbResult => {
        const ttResult = {
            timestamp: fbResult.timestamp,
            currentEncounter: fbResult.currentVisit,
        };
        switch (typeof fbResult.value) {
            case 'number': {
                const res = fbResult;
                ttResult.rawValue = res.value;
                const value = modules.value.cache.unique(variable.valueId);
                data.metadata.measurementUnitId = value?.data?.unitsId;
                if (!data.metadata.varNormal)
                    data.metadata.varNormal = [res.normalMin, res.normalMax];
                break;
            }
            case 'string': {
                const res = fbResult;
                const value = modules.value.cache.unique(res.value);
                ttResult.valueId = res.value;
                ttResult.rawValue = value ? resolveValueDisplay(value) : 'N/A';
            }
        }
        data.results.push(ttResult);
    });
    return data;
};
//# sourceMappingURL=translate-to-tooltip.js.map